module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "cont",
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "FMH",
    attrs: {
      "id": "cont"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "3",
      "id": "pg_3",
      "role": "doc-pagebreak"
    }
  }, [_c('samp', {
    staticClass: "SANS_Tiva_Regular_17"
  }, [_vm._v("Contents")])])])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "CPT1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1"
    }
  }, [_c('span', {
    staticClass: "Funkydori_Regular_17"
  }, [_vm._v("Getting Started")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("Basic Equipment")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2"
    }
  }, [_vm._v("The Sewing Machine")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter3"
    }
  }, [_vm._v("Using Patterns")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter4"
    }
  }, [_vm._v("Modifying Patterns")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter5"
    }
  }, [_vm._v("Understanding Patterns")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter6"
    }
  }, [_vm._v("Fabric Types")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter7"
    }
  }, [_vm._v("Fabric Preparation and Cutting")])]), _vm._v(" "), _c('li', {
    staticClass: "CPT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Funkydori_Regular_17"
  }, [_vm._v("Techniques")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flush Zip Pocket")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Top Edge Zip")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slimline Concealed Top Edge Zip")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Magnetic Snaps")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Open-End Straps")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Closed-End Straps")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adjustable Straps")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bound Edges")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Piped Edges")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inserting Linings: Pull Through and Turn Out Method")])]), _vm._v(" "), _c('li', {
    staticClass: "CPT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Funkydori_Regular_17"
  }, [_vm._v("Projects")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Funkydori_Regular_17"
  }, [_vm._v("The Geek-Chic iPad Case")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Funkydori_Regular_17"
  }, [_vm._v("The Compact Groceries Tote")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Funkydori_Regular_17"
  }, [_vm._v("The Access-All-Areas Pouch")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Funkydori_Regular_17"
  }, [_vm._v("The Toddler-Friendly Backpack")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Funkydori_Regular_17"
  }, [_vm._v("The ‘Too Cool for School’ Satchel")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Funkydori_Regular_17"
  }, [_vm._v("The Pleated Purse-Frame Purse")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Funkydori_Regular_17"
  }, [_vm._v("The All-Sorted Laundry Bag")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Funkydori_Regular_17"
  }, [_vm._v("The Fashionista Baby Bag")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Funkydori_Regular_17"
  }, [_vm._v("The Double-Pannier Bicycle Bag")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Funkydori_Regular_17"
  }, [_vm._v("The 3-in-1 Convertible Backpack")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Funkydori_Regular_17"
  }, [_vm._v("The Terrific Tri-Fold Wallet")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Funkydori_Regular_17"
  }, [_vm._v("The Train-Style Vanity Case")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT-TOP"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/suppliers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suppliers")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/resources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/pattern",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pattern Legend")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 60
// module chunks = 0